import "prebid.js/modules/oguryBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import type {OguryAdUnit} from "header-bidding-base/modules/config/domain/bidders/oguryConfig";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class OguryBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<OguryAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.OGURY);
    }
}
